import { Episode } from '@/types';
import { isEpisodeFree } from './isEpisodeFree';

export interface FreeEpisodeThresholdResult {
  freeEpisodesCount: number;
  threshold: number;
  shouldShowSignInModal: (episodePosition: number) => boolean;
}

export const calculateFreeEpisodeThreshold = (episodes: Episode[]): FreeEpisodeThresholdResult => {
  const freeEpisodesCount = episodes.filter(ep => isEpisodeFree(ep.is_free)).length;
  const threshold = Math.floor(freeEpisodesCount / 2);

  return {
    freeEpisodesCount,
    threshold,
    shouldShowSignInModal: (episodePosition: number) => episodePosition > threshold,
  };
};

export const shouldShowSignInModalForEpisode = (
  episodes: Episode[],
  episodeIndex: number,
  hasUser: boolean
): boolean => {
  if (hasUser) {
    return false;
  }

  const episode = episodes[episodeIndex];
  if (!episode) {
    return false;
  }

  const episodePosition = episode.episodeNumber || (episodeIndex + 1);
  const { shouldShowSignInModal } = calculateFreeEpisodeThreshold(episodes);

  return shouldShowSignInModal(episodePosition);
};

export const shouldShowSubscriptionModalForEpisode = (
  episode: Episode,
  hasUser: boolean,
  isSubscribed: boolean
): boolean => {
  if (!hasUser) {
    return false;
  }

  const episodeIsFree = isEpisodeFree(episode.is_free);
  if (episodeIsFree) {
    return false;
  }

  return !isSubscribed;
};
